import React from 'react'

const ProjectDetails = ({ project, goBack }) => {
  if (!project) return (<div/>)
  const collaborators = project.collaborators ?
    project.collaborators.map(collaborator => {
      return (
        <div className="input-group mg-b-10">
          <span className="input-group-addon"><i className="icon ion-person tx-14 lh-0 op-6"></i></span>
          <label className="form-control">{collaborator.name}</label>
        </div>)
    }) : ''
  const adminCollaborators = project.adminCollaborators ?
    project.adminCollaborators.map(adminCollaborator => {
      return (
        <div className="input-group mg-b-10">
          <span className="input-group-addon"><i className="icon ion-person tx-14 lh-0 op-6"></i></span>
          <label className="form-control">{adminCollaborator.name}</label>
        </div>)
    }) : ''
  return (
    <div>
      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
        <h4 className="tx-gray-800 mg-b-5">รายละเอียดโครงการ</h4>
      </div>
      <div className="br-pagebody">
        <div className="br-section-wrapper">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-12">
              <h2 className="mg-b-20 tx-dark tx-normal">ชื่อโครงการ : {project.name}</h2>
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between pd-y-15">
                  <h6 className="mg-b-0 tx-14 tx-inverse">Details</h6>
                </div>
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-md-8">
                        <h5 className="card-title">รายละเอียด</h5>
                        <p className="">
                          {project.description}
                        </p>
                        <h6 className="card-title">ผู้เกี่ยวข้อง</h6>
                        <div className="row col-md-6 col-lg-6">
                          {collaborators}
                        </div>
                        <h6 className="card-title mg-t-20">ผู้รับผิดชอบหลัก</h6>
                        <div className="row col-md-6 col-lg-6">
                          {adminCollaborators}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="card">
                          <a href={project.imageUrl}>
                            <img src={project.imageUrl ? project.imageUrl : 'http://via.placeholder.com/450x253?text=No%20Image'} alt="" width="100%"/>
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <br/>
              <div className="row align-items-end justify-content-end mg-r-0">
                <button type="button" className="btn btn-secondary" onClick={goBack}>กลับ</button>
              </div>
            </div>
          </div>
        </div>
      </div>    
    </div>
  )
}

export default ProjectDetails


// WEBPACK FOOTER //
// ./src/components/ProjectDetails.js